import React from 'react';

const SignUpBanner: React.FC = () => {

  return (
      <div className='hidden md:block px-8 w-full'>
        <section className='py-8 lg:py-4'>
          <div className="gap-16 items-center mx-auto max-w-screen-2xl lg:grid lg:grid-cols-2 min-h-0 lg:min-h-[300px]">
            <div className="space-y-4 bg-white/20 rounded-lg p-4 backdrop-blur">
              <h2 className="text-4xl font-bold text-fred-purple-500">Residential Broadband</h2>
              <p className="font-light text-lg text-white">Fast, Reliable Fibre Broadband, delivered by our NZ based team.</p>
            </div>
          </div>
        </section>
      </div>
  );
};

export default SignUpBanner;
